module.exports = __webpack_public_path__ + "static/img/bingtu2.9b63fa77.png";